// Copyright (c) 2017 Deere & Company

import ReportVariantModal, {getDefaultState as getReportVariantModalDefaultState} from './report-variant-modal';
import ReportLayout from '@deere/cps-it.warranty-model-factory/lib/report-layout';
import t from 'tcomb';

const ReportVariant = t.struct({
    createLayoutModal: ReportVariantModal,
    isInitialLoad: t.Boolean,
    isReportColumnsVisible: t.Boolean,
    isUpdateLayoutModalOpen: t.Boolean,
    layouts: t.list(ReportLayout, 'reportLayouts'),
    selectedLayout: t.maybe(ReportLayout)
}, 'ReportVariant');

export const getDefaultState = () =>
    new ReportVariant({
        createLayoutModal: getReportVariantModalDefaultState(),
        isInitialLoad: true,
        isReportColumnsVisible: false,
        isUpdateLayoutModalOpen: false,
        layouts: [],
        selectedLayout: null
    });

export default ReportVariant;



// WEBPACK FOOTER //
// ./src/reports/shared/state/report-variant.js